"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _prismicReactjs = require("prismic-reactjs");
var __jsx = _react["default"].createElement;
var BrandInfo = function BrandInfo(props) {
  var title = props.title,
    description = props.description,
    icon = props.icon;
  return __jsx(_Box["default"], {
    sx: {
      minHeight: "100%",
      display: "flex",
      flexDirection: "column"
    }
  }, icon && __jsx(_Box["default"], {
    sx: {
      width: "100%",
      mb: "s10"
    }
  }, __jsx(_Box["default"], {
    sx: {
      maxWidth: 300,
      m: "0 auto"
    },
    dangerouslySetInnerHTML: {
      __html: icon
    }
  })), title && __jsx(_Box["default"], {
    sx: {
      font: "heading3",
      textAlign: "left",
      color: "main",
      pb: "s8"
    }
  }, title), description && __jsx(_Box["default"], {
    sx: {
      font: "base_sans",
      color: "main",
      a: {
        color: "main"
      }
    }
  }, _prismicReactjs.RichText.render(description)));
};
var _default = BrandInfo;
exports["default"] = _default;